import { jsx } from "panel";
import { UserIconEl } from "common/widgets/user-icon";
import { ModalEl } from "common/components/modal";
import { ButtonEl } from "common/components/button";
import { IconSizeType } from "common/constants";
import { ButtonTheme } from "common/components/button/constants";
export function template() {
  return /* @__PURE__ */ jsx("div", {
    sel: ".avatar-upload-container"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".avatar"
  }, /* @__PURE__ */ jsx(UserIconEl, {
    attrs: {
      elref: `avatarUserIcon`,
      id: this.params.id,
      name: this.params.name,
      size: IconSizeType.XL,
      "img-src": this.helpers.getAvatarUrl()
    }
  }), /* @__PURE__ */ jsx("input", {
    attrs: {
      elref: `fileInput`,
      type: `file`,
      style: `display: none;`,
      accept: `image/png, image/jpeg`
    },
    hook: {
      insert: this.helpers.fileInputInserted
    },
    on: {
      change: () => this.helpers.handleFileInputChange()
    }
  }), /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".upload-button",
    attrs: {
      elref: `uploadButton`,
      theme: ButtonTheme.Primary,
      icon: `edit`
    },
    on: {
      click: this.helpers.handleUploadClick
    }
  })), this.params.hideName ? null : /* @__PURE__ */ jsx("div", {
    sel: ".name"
  }, this.params.name), /* @__PURE__ */ jsx(ModalEl, {
    attrs: {
      closeable: !this.state.isEditingImage,
      open: this.state.isUploadModalOpen
    },
    on: {
      change: (ev) => this.helpers.handleModalChange(ev)
    }
  }, this.state.isUploadModalOpen && /* @__PURE__ */ jsx("div", {
    sel: ".upload-avatar-modal"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".title"
  }, "Update Profile Photo"), /* @__PURE__ */ jsx("div", {
    sel: ".avatar-editor"
  }, /* @__PURE__ */ jsx("img", {
    sel: "#avatar-image",
    attrs: {
      src: this.state.sourceImage || ``
    },
    on: {
      load: (ev) => this.helpers.avatarImgElementLoad(ev.target)
    }
  })), /* @__PURE__ */ jsx("div", {
    sel: ".actions"
  }, /* @__PURE__ */ jsx(ButtonEl, {
    attrs: {
      elref: `saveAvatarButton`,
      theme: ButtonTheme.Primary
    },
    on: {
      click: this.helpers.handleImageCropped
    }
  }, "Save")))));
}
